// Google Analytics 4 (GA4) Utility
export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-BZF40V2VSC';

let isInitialized = false;

/**
 * Initialize Google Analytics 4
 */
export const initGA = () => {
  if (typeof window === 'undefined' || !GA_MEASUREMENT_ID || isInitialized) {
    return;
  }

  // Ensure dataLayer and gtag are available globally
  window.dataLayer = window.dataLayer || [];
  if (!window.gtag) {
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
  }

  // Check if script already exists in document
  const existingScript = document.querySelector(
    `script[src*="googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}"]`
  );

  if (!existingScript) {
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    script.async = true;
    document.head.appendChild(script);
  }

  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, {
    send_page_view: false, // Page views handled dynamically by RouteTracker
  });

  isInitialized = true;
};

/**
 * Track virtual page view for SPA routing
 * @param {string} path - pathname + search
 */
export const trackPageView = path => {
  if (typeof window === 'undefined' || !window.gtag || !GA_MEASUREMENT_ID) {
    return;
  }

  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: path,
  });

  window.gtag('event', 'page_view', {
    page_path: path,
    page_title: document.title,
    page_location: window.location.href,
  });
};

/**
 * Track custom event in GA4
 * @param {string} eventName
 * @param {object} params
 */
export const trackEvent = (eventName, params = {}) => {
  if (typeof window === 'undefined' || !window.gtag) {
    return;
  }
  window.gtag('event', eventName, params);
};
